import { render, staticRenderFns } from "./ReportCarriers.vue?vue&type=template&id=6a0fe49a&scoped=true&"
import script from "./ReportCarriers.vue?vue&type=script&lang=js&"
export * from "./ReportCarriers.vue?vue&type=script&lang=js&"
import style0 from "./ReportCarriers.vue?vue&type=style&index=0&id=6a0fe49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0fe49a",
  null
  
)

export default component.exports